import { Button, ButtonGroup, Col, Row, Table } from "react-bootstrap";
import { handleFieldChange } from "../../Utils";

import SelectWrap from "../../components/SelectWrap";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import Form from "./components/Form";

import React from "react";
import API from "../../services/API";

import './index.css'

class AdkPreDefinedDomains extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            syncData: null,
            servers: {},
            domains: [],
            form: null,
            filters: {},
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.load_data = this.load_data.bind(this);

        this.on_remove_submit = this.on_remove_submit.bind(this);
        this.on_create_submit = this.on_create_submit.bind(this);
        this.on_edit_submit = this.on_edit_submit.bind(this);
    }

    componentDidMount() {
        this.load_data().catch(console.error);
    }

    async load_data() {
        this.setState({ loading: true });

        const filters = {};

        if (this.state.filters.type) filters.type = this.state.filters.type;
        if (this.state.filters.status) filters.status = this.state.filters.status;

        const domains = await API.AdkPreDefinedDomains.get(filters);

        const servers = {
            'webserver': await API.Servers.get('webserver'),
            'adk-haproxy': await API.Servers.get('adk-haproxy'),
        };

        this.setState({ loading: false, domains, servers });
    }

    async on_remove_submit(entity) {
        if (!window.confirm(`Are you sure to delete: "${entity.domain}"?`)) return;

        this.setState({ loading: true });

        await API.AdkPreDefinedDomains.remove(entity);

        await this.load_data();
    }

    async on_create_submit(entity) {
        this.setState({ loading: true });

        await API.AdkPreDefinedDomains.create(entity);

        this.setState({ form: null });

        await this.load_data();
    }

    async on_edit_submit(entity) {
        if (!window.confirm(`Domain: "${this.state.form.domain}" => "${entity.domain}"\nStatus: "${this.state.form.status}" => "${entity.status}"`)) return;

        this.setState({ loading: true });

        delete entity.created_at;
        delete entity.updated_at;

        await API.AdkPreDefinedDomains.update(entity);

        this.setState({ form: null });

        await this.load_data();
    }

    render() {
        return (
            <Container loading={this.state.loading}>
                <Heading title="ADK Pre Defined Domains" />

                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button bsStyle="success" onClick={() => this.setState({ form: { status: 'new' } })}>Create</Button>
                </div>

                { this.state.form && <Form entity={this.state.form} on_edit={this.on_edit_submit} on_create={this.on_create_submit} on_hide={() => this.setState({ form: null })} />}

                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={[ 'partner-domains', 'click-domains' ]}
                            label="Type:"
                            name="filters.type"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.type}
                            multi
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={[ 'new', 'used' ]}
                            label="Status:"
                            name="filters.status"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.status}
                            multi
                        />
                    </Col>
                </Row>

                <Row style={{ marginBottom: '15px' }}>
                    <Col lg={12}>
                        <Button bsStyle="primary" onClick={this.load_data}>Load</Button>
                    </Col>
                </Row>

                <Table bordered responsive style={{ width: '100vw', textAlign: 'center', verticalAlign: 'middle' }}>
                    <thead>
                    <tr>
                        <th>Type</th>
                        <th>Domain</th>
                        <th>Status</th>
                        <th>DNS Valid</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Actions</th>
                    </tr>
                    </thead>

                    <tbody>
                        {this.state.domains.map((entity, index) => {
                            const server_type = {
                                'click-domains': 'adk-haproxy',
                                'partner-domains': 'webserver'
                            }[entity.type];

                            const servers = this.state.servers[server_type] || [];

                            const dns_valid = servers.some((server) => server.ip === entity.dns);

                            return (
                                <tr key={index}>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.type}</th>
                                    <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.domain}</th>
                                    <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.status}</td>

                                    <td style={{ width: '0.1%', verticalAlign: 'middle', textAlign: 'center'}}>
                                        <div style={{ display: 'inline-block', width: '20px', height: '20px', background: dns_valid ? 'green' : 'red', borderRadius: '50%' }} title={entity.dns}></div>
                                    </td>

                                    <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.created_at}</td>
                                    <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.updated_at}</td>

                                    <td style={{ width: '1%', verticalAlign: 'middle' }}>
                                        <ButtonGroup>
                                            <Button bsStyle={'primary'} onClick={() => this.setState({ form: entity })}>Edit</Button>

                                            <Button bsStyle={'danger'} onClick={() => this.on_remove_submit(entity)}>Remove</Button>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Container>
        )
    }
}

export default AdkPreDefinedDomains;



// WEBPACK FOOTER //
// ./src/scenes/AdkPreDefinedDomains/index.js